import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import Button from '@mui/material/Button';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import AttachmentIcon from '@mui/icons-material/Attachment';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import ClosedCaptionOutlinedIcon from '@mui/icons-material/ClosedCaptionOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import StayPrimaryPortraitIcon from '@mui/icons-material/StayPrimaryPortrait';

import classes from './SpecificSection.module.css';

const SpecificSection = ({ courseData, users, lessons }) => {
  const { productType, idProduct, academyName } = useParams();

  return (
    <div className={classes.specificSectionContainer}>
      <figure className={classes.imgCourse}>
        <img
          className={classes.img}
          src={courseData.path}
          alt={courseData.name}
        />
      </figure>
      <p className={classes.price}>
        ${new Intl.NumberFormat('en-US').format(courseData.price)}.
        <sup style={{ fontSize: 11 }}>{courseData.cents}</sup>{' '}
        {courseData.currency}
      </p>
      <Button
        className={classes.btnPay}
        component="a"
        target="_blnak"
        href={`${process.env.REACT_APP_API_URL_PAGOS}/cart/checkout/${productType}/${courseData.idEmisor}/${academyName}/${idProduct}`}
      >
        <ShoppingCartOutlinedIcon className={classes.btnIcon} />{' '}
        Continuar con la compra
      </Button>
      <aside className={classes.itemsDescriptionsContainer}>
        <p className={classes.itemDescriptionContainer}>
          <GroupOutlinedIcon className={classes.productIcon} />
          <span className={classes.textItem}>
            Alumnos inscritos: {users}
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <MovieOutlinedIcon className={classes.productIcon} />
          <span className={classes.textItem}>
            {lessons.lessonExtraInfo.lessons.total} lecciones
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <AttachmentIcon className={classes.productIcon} />
          <span className={classes.textItem}>
            {lessons.lessonExtraInfo.lessonActivities.activities}{' '}
            Actividades
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <SentimentSatisfiedIcon className={classes.productIcon} />
          <span className={classes.textItem}>Online a tu ritmo</span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <WatchLaterOutlinedIcon className={classes.productIcon} />
          <span className={classes.textItem}>
            Duración de{' '}
            {lessons.lessonExtraInfo.lessons.seconds / 60 / 60} horas
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <VolumeUpOutlinedIcon className={classes.productIcon} />
          <span className={classes.textItem}>Audio Español</span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <ClosedCaptionOutlinedIcon
            className={classes.productIcon}
          />
          <span className={classes.textItem}>Español</span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <ConfirmationNumberOutlinedIcon
            className={classes.productIcon}
          />
          <span className={classes.textItem}>
            Cupón de descuento
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <StayPrimaryPortraitIcon className={classes.productIcon} />
          <span className={classes.textItem}>
            Acceso en dispositivos móviles
          </span>
        </p>
        <p className={classes.itemDescriptionContainer}>
          <figure className={classes.iconContainerDegree}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_DiplomaFinalizacion.png"
            />
          </figure>
          <span className={classes.textItem}>
            Diploma de finalización de curso
          </span>
        </p>
      </aside>
    </div>
  );
};

SpecificSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  courseData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  lessons: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  reviews: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  users: PropTypes.number
};

export default SpecificSection;
